class localhostSettings { }

const win: any = window;
if (window.location.href.includes("localhost")) {
    document.documentElement.lang = win["lang"];
}

export default localhostSettings;
